<template>
    <div class="component-compare" v-bind:class="{'down':!isUp}">
      <i v-if="isUp">&#8599;</i>
      <i v-if="!isUp">&#8600;</i>
      <div class="component-compare-popin">
        <span v-if="isUp" class="component-compare-title">En hausse de</span>
        <span v-if="!isUp" class="component-compare-title">En baisse de</span>
        <strong v-if="is_amount"><i>{{ currency }}</i> {{ difference|formatNumber }}</strong>
        <strong v-if="!is_amount">{{ difference }}</strong>
        <span>{{amount_previous|formatNumber}} => {{amount_current|formatNumber}}</span>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'Compare',
        props: ['value','previous','current','currency'],
        data: function () {
            return {
              amount_previous: 0,
              amount_current: 0,
              difference: 0
            }
        },
        created: function() {
          this.is_amount = this.currency ? true : false
          this.amount_previous = !isNaN(this.previous) ? this.previous : 0;
          this.amount_current = !isNaN(this.current) ? this.current : 0;
          this.update();
        },
        methods: {
          update: function()
          {
            this.isUp = this.amount_current >= this.amount_previous ? true : false;
            this.difference = Math.abs(this.amount_current - this.amount_previous);

            if( this.difference == 0 )
            {
              this.isUp = true;
            }
          }
        },
        watch: {
          'previous'(newVal, oldVal) {
            this.amount_previous = newVal;
            this.update();
          },
          'current'(newVal, oldVal) {
            this.amount_current = newVal;
            this.update();
          }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Compare.vue